<script setup>
import DashboardSorter from "@/components/dashboard/DashboardSorter.vue";
import SidebarNavigation from "@/components/dashboard/SidebarNavigation.vue";
import RecommendationDialog from "@/components/dashboard/RecommendationDialog.vue";
import { computed, ref } from "vue";
import { getFilteredSidebarData } from "@/services/constant-services";
import { useUserStore } from "@/store/user-store";

// Make sidebar data reactive to store changes
const data = computed(() => getFilteredSidebarData());
const store = useUserStore();

const isRecommendationDialogOpen = ref(false);

const openRecommendationDialog = () => {
  isRecommendationDialogOpen.value = true;
};

// Check if we should show Portfolio Commentary button
const showPortfolioCommentary = computed(() => {
  return store.userTab === 'Dashboard' && !store.isDashboardLoading && store.dashboardData;
});
</script>

<template>
  <div class="container gap-20 m-auto w-fs h-fs d-flex">
    <SidebarNavigation />
    <DashboardSorter :data="data">
      <template #header-actions>
        <button
          v-if="showPortfolioCommentary"
          class="portfolio-commentary-btn"
          @click="openRecommendationDialog"
        >
          <i class="pi pi-volume-up"></i>
          Portfolio Commentary
        </button>
      </template>
    </DashboardSorter>

    <!-- Recommendation Dialog -->
    <RecommendationDialog
      v-model:isRecommendationDialogOpen="isRecommendationDialogOpen"
    />
  </div>
</template>

<style scoped>
.container {
  padding: 20px;
  background-color: var(--an-background-light);
  overflow: hidden;
  height: 100vh;
}

/* Portfolio Commentary Button - Styled for header placement */
.portfolio-commentary-btn {
  background: var(--an-primary, #0d7c68);
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 2px 4px rgba(13, 124, 104, 0.2);
  transition: all 0.2s ease;
  white-space: nowrap;
  height: 40px;
  margin-left: 40px;
}

.portfolio-commentary-btn:hover {
  background: var(--an-primary-dark, #0a6454);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(13, 124, 104, 0.3);
}

.portfolio-commentary-btn:active {
  transform: translateY(0);
}

.portfolio-commentary-btn i {
  font-size: 14px;
}

@media (max-width: 1200px) {
  .container {
    padding: 0px;
    flex-direction: column;
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .portfolio-commentary-btn {
    font-size: 12px;
    padding: 8px 16px;
    height: 36px;
    margin-left: 20px;
    gap: 6px;
  }

  .portfolio-commentary-btn i {
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .portfolio-commentary-btn {
    font-size: 11px;
    padding: 6px 12px;
    height: 32px;
    margin-left: 12px;
    gap: 4px;
  }

  .portfolio-commentary-btn i {
    font-size: 12px;
  }
}

@media (max-width: 360px) {
  .portfolio-commentary-btn {
    font-size: 10px;
    padding: 5px 10px;
    height: 30px;
    margin-left: 8px;
  }

  .portfolio-commentary-btn i {
    font-size: 11px;
  }
}
</style>
